module.exports = __webpack_public_path__ + "img/lg_ring_y_o_0_1.5478b67f.png";